<template>
  <el-form ref="formRef" :model="form" label-width="80px" :label-position="getIsMobile?'top':'right'" >
    <el-form-item label="地址" prop="kpaddress">
      <el-input type="text" placeholder="请输入地址" v-model="form.kpaddress"/>
    </el-form-item>
    <el-form-item label="座机" prop="tel">
      <el-input type="text" placeholder="请输入座机号" v-model="form.tel"/>
    </el-form-item>
    <el-form-item label="传真" prop="max">
      <el-input type="text" placeholder="请输入传真号" v-model="form.max"/>
    </el-form-item>
    <el-form-item label="开户行" prop="bank">
      <el-input type="text" placeholder="请输入开户行" v-model="form.bank"/>
    </el-form-item>
    <el-form-item label="账号" prop="banknum">
      <el-input type="text" placeholder="请输入账号" v-model="form.banknum"/>
    </el-form-item>
    <el-form-item label="税号" prop="kpsbnum">
      <el-input type="text" placeholder="请输入税号" v-model="form.kpsbnum"/>
    </el-form-item>
    <el-form-item label="备注" prop="kpbz">
      <el-input type="text" placeholder="请输入备注" v-model="form.kpbz"/>
    </el-form-item>
    <el-form-item label="合同条款" prop="company_content" class="editor">
      <div ref="contractEditor" class="contractEditor"></div>
    </el-form-item>
  </el-form>
</template>
<script>
import { defineComponent, getCurrentInstance, nextTick, onMounted, reactive, ref, watch,toRaw } from '@vue/composition-api'
import useRootSetting from '@/hooks/useRootSetting'
import request from '@/utils/request'

import E from 'wangeditor'
export default defineComponent({
  components: {},
  props: {
    id: {
      type: [String,Number],
      default: ''
    }
  },
  setup(props,{ emit}) {
    const instance = getCurrentInstance()
    const username = instance.proxy.$store.getters.name
    const {getIsMobile} = useRootSetting()
    const formRef = ref(null)
    const contractEditor = ref(null)
    const defaultForm = () => ({
      kpsbnum:'',
      kpaddress:'',
      tel:'',
      max:'',
      bank:'',
      banknum:'',
      kpbz:'',
      company_content:''
    })
    const form = reactive(defaultForm())

    const handleReset = () => Object.assign(form,defaultForm())

    const getInvoiceInfo = () => {
      request({
        method: 'post',
        url:'customer_info_list.yy',
        data: {
          username:username,
          id: props.id
        }
      }).then(res => {
        if(res.code == 200){
          const dataCopy = { ...res.data[0] };
          emit('getInfo',dataCopy)
          contractEditor.value.txt.html(res.data[0].company_content)
          const {kpaddress,tel,max,bank,banknum,kpsbnum,kpbz} = res.data[0]
          Object.assign(form, {kpaddress,tel,max,bank,banknum,kpsbnum,kpbz});
        }
      })
    }

    onMounted(async () => {
      await nextTick()
      contractEditor.value = new E(contractEditor.value) //合同条款
      contractEditor.value.create()
      nextTick(() => {
        contractEditor.value.config.zIndex = 1000
      })
      contractEditor.value.config.onchange = (newHtml) => {
        form.company_content = newHtml
      }
      getInvoiceInfo()
    })


    return {
      username,
      contractEditor,
      getIsMobile,
      formRef,
      form,
      handleReset
    }
  }
})
</script>
